import axios from 'axios'
import { setAuthUser } from '../../redux/actions/auth'
import { history, store } from '../../redux/store'

const { dispatch } = store

axios.interceptors.response.use(undefined, (error) => {
  if (error.response.status === 403) {
    localStorage.removeItem('token')
    dispatch(setAuthUser(false))
    history.push('/login')
  }
  return Promise.reject(error)
})

// TODO need to investigate
const headers = () => {
  if (localStorage.getItem('token')) {
    return {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    }
  }
  return {}
}

export const GET = async (url, queryParams) => {
  try {
    const response = await axios.get(url, {
      headers: headers(),
      params: queryParams,
    })
    return {
      success: true,
      status: response.status,
      data: response.data,
    }
  } catch (error) {
    return {
      success: false,
      status: error.status || 500,
      msg: error.response.data.msg || 'Internal server error..',
    }
  }
}

export const POST = async (url, queryParams, body) => {
  try {
    const response = await axios.post(`${url}`, body, {
      headers: headers(),
      params: queryParams,
      // baseURL: process.env,
    })
    return {
      success: true,
      message: response.data.message || '',
      status: response.status,
      data: response.data,
    }
  } catch (error) {
    return {
      success: false,
      status: error.response.status,
      msg:
        error.response.data.msg ||
        error.response.data.errors ||
        'Internal server error.',
    }
  }
}

export const PUT = async (url, queryParams, body) => {
  try {
    const response = await axios.put(`${url}`, body, {
      headers: headers(),
      params: queryParams,
    })
    return {
      success: response.data.success,
      status: response.status,
      data: response.data,
      errors: response.data.errors,
    }
  } catch (error) {
    return {
      success: false,
      msg:
        error.response.data.msg ||
        error.response.data.errors ||
        'Internal server error.',
    }
  }
}

export const DELETE = async (url, queryParams) => {
  try {
    const response = await axios.delete(`${url}?${queryParams}`, {
      headers: headers(),
    })
    return {
      success: response.data.success,
      status: response.status,
      data: response.data,
      errors: response.data.errors,
    }
  } catch (error) {
    return {
      success: false,
      msg: error.response.data.msg || 'Internal server error..',
    }
  }
}
